module.exports = __webpack_public_path__ + "img/p52.b60cdf59.jpg";